export const styles = {
  infoContainer: {
    flex: 1,
    display: 'flex',
  },
  buttonsContainer: {
    padding: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 0,
  },
  imageColumn: {
    marginRight: '20px',
    minWidth: '80px',
  },
  info: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  imageContainer: {
    position: 'relative',
    width: '80px',
    height: '80px',
  },
  image: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    position: 'absolute',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  cameraIcon: {
    position: 'absolute',
    bottom: '0',
    right: '0',
    padding: '0',
  },
  userName: {
    fontSize: '22px',
    fontWeight: '700',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  row: {
    display: 'flex',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px',
    marginRight: '30px',
    width: '30%',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0px',
    },
  },
  infoItemTitle: {
    color: '#707087',
    marginBottom: '5px',
    fontWeight: '200',
    fontSize: '14px',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  value: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  column: {
    marginRight: '30px',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '345px',
    width: '100%',
    height: '100%',
  },
  error: {
    fontSize: 'small',
    color: 'red',
    marginTop: '5px',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },

  profileButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '16px',
    border: '1px solid',
    marginLeft: '20px',
    padding: '8px 16px',
    backgroundColor: '#FFFFFF',
    minWidth: '124px',
    fontWeight: '700',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  saveButton: {
    border: '1px solid #004360',
    backgroundColor: '#004360',
    color: '#FFFFFF',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  disabled: {
    backgroundColor: '#E0E0E0',
    border: '1px solid #E0E0E0',
  },
}
